import { jsx as _jsx } from "react/jsx-runtime";
export function getBoxes(nodes) {
    const boxes = [];
    appendBoxes(nodes, boxes);
    return boxes;
}
function appendBoxes(nodes, boxes) {
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        boxes.push(_jsx("g", { transform: `translate(${node.position.x} ${node.position.y})`, children: node.element }, i));
        if (node.children) {
            appendBoxes(node.children, boxes);
        }
    }
}
//# sourceMappingURL=getBoxes.js.map